export const forgivenessSummaryTileSelector = (state) => ({
  advancesById: state.entities.advances.byId,
  forgivenessById: state.entities.loanForgiveness.byId,
  forgivenessCustomerSignoffEnabled: state.config.forgivenessCustomerSignoffEnabled,
  forgiveness3508SEnhancedSbaResponseReceivedEnabled: state.config.forgiveness3508SEnhancedSbaResponseReceivedEnabled,
});
